import React from 'react';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';

const UserFormFileUploadInput = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const formFileUploadClasses = classes.push('w-file-upload-input');
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const field = data.users?.field;
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const fieldType = data.users?.fieldType;
    const attributeWithField = field
      ? attributes.set(USYS_DATA_ATTRS.field, field)
      : attributes;

    return (
      <input
        {...generateAttributes(
          fieldType
            ? attributeWithField.set(USYS_DATA_ATTRS.fieldType, fieldType)
            : attributeWithField,
          formFileUploadClasses
        )}
      />
    );
  }
);

const config = Atom.create({
  displayName: 'Input',
  constraints: {
    ancestors: [
      {
        is: ['UserSignUpForm', 'UserAccountForm'],
        name: 'User Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: UserFormFileUploadInput,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('UserFormFileUploadInput'))
  ),
  hideAncestorSettings: true,
});

export default config;
